<template>
  <el-card>
    <el-row class="gear_reward__title">档位奖励配置</el-row>
    <!-- 搜索 -->
    <el-row class="gear_reward__search">
      <span>档位类型</span>
      <el-select
        v-model="search.gearType"
        style="width: 200px"
        filterable
        clearable
        placeholder="请选择"
      >
        <el-option
          v-for="(item, index) in gearTypes"
          :key="index"
          :label="item.name"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span>状态</span>
      <el-select v-model="search.valid" clearable placeholder="请选择">
        <el-option key="0" label="下线" :value="0"> </el-option>
        <el-option key="1" label="上线" :value="1"> </el-option>
      </el-select>
      <el-button
        style="margin-left: 10px"
        type="primary"
        @click="getAllRewardConfig(0)"
        >搜索</el-button
      >
      <el-button
        style="margin-left: 10px"
        type="primary"
        @click="
          () => {
            type = 1
            isShow = true
          }
        "
        >添加</el-button
      >
    </el-row>
    <!-- 表格 -->
    <el-row>
      <el-table border :data="tableList">
        <el-table-column prop="level" label="等级" align="center">
        </el-table-column>
        <el-table-column label="档位类型" align="center">
          <template slot-scope="scope">
            {{
              gearTypes.find((item) => item.value == scope.row.gearType).name
            }}
          </template>
        </el-table-column>
        <el-table-column prop="conditionVal" label="条件" align="center">
        </el-table-column>
        <el-table-column prop="operator" label="操作人" align="center">
        </el-table-column>
        <el-table-column
          prop="mtime"
          label="创建时间"
          align="center"
          :formatter="formatDate"
        >
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            {{ scope.row.valid === 0 ? '下线' : '上线' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="210">
          <template slot-scope="scope">
            <el-button type="primary" @click="copyOrUpdate(scope.row, 1)"
              >编辑</el-button
            >
            <el-button type="success" @click="copyOrUpdate(scope.row, 2)"
              >复制</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 分页 -->
    <el-row>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="totalPage"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        @current-change="guaranteedHandleCurrentChange"
      >
      </el-pagination>
    </el-row>
    <!-- 配置弹框 -->
    <el-dialog
      :visible.sync="isShow"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="档位配置"
    >
      <el-row class="item">
        <span>等级</span>
        <el-input
          v-model.number="formData.level"
          placeholder="请输入等级"
          type="number"
          style="width: 300px"
        ></el-input>
      </el-row>
      <el-row class="item">
        <span>条件</span>
        <el-input
          v-model="formData.conditionVal"
          placeholder="请输入条件"
          type="textarea"
          autosize
          style="width: 300px"
        ></el-input>
      </el-row>
      <el-row class="item">
        <span>档位类型 </span>
        <el-select
          v-model="formData.gearType"
          filterable
          clearable
          placeholder="请选择"
          style="width: 200px"
        >
          <el-option
            v-for="item in gearTypes"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-row>
      <el-row class="item">
        <span>状态</span>
        <el-switch
          v-model="formData.valid"
          active-text="上线"
          inactive-text="下线"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </el-row>
      <el-row class="item">
        <span style="font-weight: bold; font-size: 18px; width: max-content"
          >奖励列表</span
        >
      </el-row>
      <el-row
        v-for="(item, index) in formData.rewardList"
        :key="index"
        style="border: 2px dotted #ccc; padding: 15px 10px"
      >
        <el-row class="item">
          <span>物品id</span>
          <el-input
            v-model.number="item.itemsId"
            placeholder="请输入id"
            type="number"
            style="width: 300px"
          ></el-input>
        </el-row>
        <el-row class="item">
          <span>物品数量</span>
          <el-input
            v-model.number="item.itemsNum"
            placeholder="请输入数量"
            type="number"
            style="width: 300px"
          ></el-input>
        </el-row>
        <el-row class="item">
          <span>物品类型 </span>
          <el-select
            v-model="item.itemsType"
            filterable
            clearable
            placeholder="请选择"
            style="width: 200px"
          >
            <el-option
              v-for="item in RewardTypes"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-row>
        <el-row>
          <el-button
            type="danger"
            icon="el-icon-delete"
            circle
            @click="formData.rewardList.splice(index, 1)"
          ></el-button>
        </el-row>
      </el-row>
      <el-row style="display: flex; justify-content: center">
        <el-button
          type="primary"
          icon="el-icon-plus"
          circle
          @click="
            formData.rewardList.push({
              itemsId: null,
              itemsNum: null,
              itemsType: null,
            })
          "
        ></el-button>
      </el-row>
      <el-row>
        <el-button type="primary" @click="cancel">取消</el-button>
        <el-button type="primary" @click="submit">确认</el-button>
      </el-row>
    </el-dialog>
  </el-card>
</template>

<script>
import { type } from 'vue-json-editor/assets/jsoneditor'

export default {
  data() {
    return {
      // 0 编辑 1 添加
      type: 0,
      isShow: false,
      // 每页显示数量
      pageSize: 10,
      // 总页数
      totalPage: 10,
      // 当前页数
      currentPage: 0,
      // 表单数据
      tableList: [],
      // 挡位类型
      gearTypes: [],
      // 奖励类型
      RewardTypes: [],
      // 搜索数据
      search: {
        gearType: null,
        valid: null,
      },
      formData: {
        level: null,
        gearType: null,
        conditionVal: null,
        valid: 0,
        rewardList: [
          {
            itemsId: null,
            itemsNum: null,
            itemsType: null,
          },
        ],
      },
    }
  },
  mounted() {
    this.getAllPullDown()
  },
  methods: {
    getAllPullDown() {
      this.getGearType()
      this.getRewardType()
      this.getAllRewardConfig(0)
    },
    // 取消
    cancel() {
      this.formData = {
        level: null,
        gearType: null,
        conditionVal: null,
        valid: 0,
        rewardList: [
          {
            itemsId: null,
            itemsNum: null,
            itemsType: null,
          },
        ],
      }
      this.isShow = false
    },
    // 编辑或复制
    copyOrUpdate(info, status) {
      let data = JSON.parse(JSON.stringify(info))
      if (status == 1) {
        this.type = 0
      } else {
        data.id = null
        this.type = 1
      }
      this.formData = {
        id: data.id,
        level: data.level,
        gearType: data.gearType,
        conditionVal: data.conditionVal,
        valid: data.valid,
        rewardList: data.rewardList,
      }
      this.isShow = true
    },
    // 确认提交
    async submit() {
      const res = await this.updateGear(this.formData)
      console.log(res)
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('修改成功')
        this.cancel()
        this.getAllRewardConfig()
      }
    },
    //修改状态
    async changeValid(info) {
      const userInfo = JSON.parse(JSON.stringify(info))
      userInfo.valid = Math.abs(userInfo.valid - 1)
      userInfo = {
        id: userInfo.id,
        valid: userInfo.valid,
      }
      const res = await this.updateGear(userInfo)
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('修改成功')
        this.getAllRewardConfig()
      }
    },
    // 修改档位配置
    async updateGear(info) {
      let url =
        this.type === 0
          ? this.$store.getters.path.config_gearConfig_post
          : this.$store.getters.path.config_gearConfig_add
      let data = JSON.parse(JSON.stringify(info))

      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data,
      })
      return res
    },
    //页数改变
    guaranteedHandleCurrentChange(page) {
      this.getAllRewardConfig(page)
    },
    // 格式化时间
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property] * 1000
      if (data == null) {
        return null
      }
      let dt = new Date(data)
      return (
        dt.getFullYear() +
        '-' +
        (dt.getMonth() + 1) +
        '-' +
        dt.getDate() +
        ' ' +
        dt.getHours() +
        ':' +
        dt.getMinutes() +
        ':' +
        dt.getSeconds()
      )
    },
    // 获取挡位类型
    async getGearType() {
      const { data: res } = await this.$axios({
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.config_gearType_query,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.gearTypes = res.data
      }
    },
    // 获取奖励类型
    async getRewardType() {
      const { data: res } = await this.$axios({
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.config_rewardType_query,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.RewardTypes = res.data
      }
    },
    // 获取所有挡位配置
    async getAllRewardConfig(page) {
      let pages = page || this.currentPage
      let info = {
        ...this.search,
        page: pages,
      }

      const { data: res } = await this.$axios({
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.config_gearConfig_query,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          ...info,
        },
      })
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.totalPage = res.data.total
        this.tableList = res.data.data
      }
    },
  },
}
</script>

<style scoped lang="scss">
.gear_reward {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  &__search {
    span {
      font-size: 20px;
      font-weight: 600;
      margin-right: 15px;
      margin-left: 15px;
    }

    .searchBtn {
      margin-left: 10px;
    }
  }
}

.item {
  span {
    display: inline-block;
    width: 70px;
    font-size: 16px;
    text-align: right;
    margin-right: 10px;
  }
}
</style>
